export default __webpack_public_path__ + "static/media/pesquisa.ba568b6e.svg";